import { render, staticRenderFns } from "./HeroSelector.vue?vue&type=template&id=1e0ecd52&scoped=true&"
import script from "./HeroSelector.vue?vue&type=script&lang=js&"
export * from "./HeroSelector.vue?vue&type=script&lang=js&"
import style0 from "./HeroSelector.vue?vue&type=style&index=0&id=1e0ecd52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0ecd52",
  null
  
)

export default component.exports